import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SFTypography from "../typography";
import SFContainer from "../container";
import Drawer from "@mui/material/Drawer";
import { PopupTitle } from "./popupTitle";
import { PopupPanelBody } from "./popupPanelBody";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

export const DrawerHeader = styled("div", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  position: "sticky",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "space-between",
  paddingLeft: "20px",
  paddingRight: "8px",
  minHeight: "auto",
  borderBottom: `1px solid ${theme.palette.grey225.main}`,
}));

const SFNotificationPanel = (props) => {
  const { t } = useTranslation();
  const anchorPosition = "right";

  return (
    <Drawer
      anchor={anchorPosition}
      open={props.show}
      onClose={props.onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "360px",
        },
        "& .action-buttons": {
          mr: 1,
        },
      }}
    >
      <PopupTitle {...props}/>
      {props.notifications.length > 0 && <PopupPanelBody {...props}/>}
      {props.notifications.length === 0 && (
        <SFContainer sx={{ marginTop: 2, textAlign: "center" }}>
          <SFTypography variant="body1">
            {t("components.header.notificationPanel.noMessagesLabel")}
          </SFTypography>
        </SFContainer>
      )}
    </Drawer>
  );
};

export default SFNotificationPanel;

SFNotificationPanel.propTypes = {
  show: PropTypes.bool,
  /** The function to call when the notification panel is closed. */
  onClose: PropTypes.func,
};
